import React from 'react';
import { Title, UnstyledButton } from '@mantine/core';

const StepperButton = ({ label, isActive, status, onClick, disabled = false }) => {
  const getDotColor = () => {
    switch (status) {
      case -1: return 'dot-none';
      case 0: return 'dot-red';
      case 1: return 'dot-yellow';
      case 2: return 'dot-green';
      default: return "dot-red"; // Mensaje por defecto
    }
  };

  return (
    <UnstyledButton
      onClick={onClick}
      disabled={disabled}
      miw={'5.5rem'}
      w={'auto'}
      className={`stepper-button ${isActive ? 'active' : ''}`}
    >
      <Title order={1} fw={500}>{label}</Title>
      <div className={`stepper-dot ${getDotColor()}`}></div>
    </UnstyledButton>
  );
};

export default StepperButton;